import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const SpinnerPurpleDouble = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <circle cx={8} cy={8} fill="none" r={6} stroke="currentColor" strokeDasharray={48} strokeWidth={1.1}>
      <animate attributeName="stroke-dashoffset" dur="3.5s" from={96} repeatCount="indefinite" to={0} />
      <animateTransform attributeName="transform" dur="2s" from="0 8 8" repeatCount="1" to="360 8 8" type="rotate" />
    </circle>
    <circle cx={8} cy={8} fill="none" r={3} stroke="currentColor" strokeDasharray={48} strokeWidth={1.1}>
      <animate attributeName="stroke-dashoffset" dur="3.5s" from={96} repeatCount="indefinite" to={0} />
      <animateTransform attributeName="transform" dur="2s" from="0 8 8" repeatCount="1" to="360 8 8" type="rotate" />
    </circle>
  </Icon>
));

export default SpinnerPurpleDouble;
